import script from "./ResultTableHead.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultTableHead.vue?vue&type=script&setup=true&lang=ts"

import "./ResultTableHead.vue?vue&type=style&index=0&id=5929e854&lang=scss&scoped=true"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5929e854"]])

export default __exports__